import { Button, makeStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { XMEI_PRIMARY_COLOR, XMEI_SECONDARY_COLOR } from 'src/consts/common';

export const useStyles = makeStyles((theme) => ({
  titleBankSlip: { alignItems: 'center', marginVertical: 20, marginBottom: 20 },
  paper: {
    padding: '15px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  formControl: {
    margin: '6px 0',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  cupomContainer: {
    marginTop: '0.5em',
  },
  group: {},
  formGroupTitle: {
    position: 'absolute',
    top: -10,
    left: 8,
    fontWeight: 600,
    padding: '0 4px',
    backgroundColor: theme.palette.background.paper,
  },
  formGroup: {
    position: 'relative',
    border: '1px solid ',
    borderRadius: 2,
    padding: '12px 12px 0 12px',
    margin: '24px 0 16px 0',
    '&:first-of-type': {
      marginTop: 16,
    },
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  cssFocused: {},
  loadingCard: {
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
  },
  search: {
    margin: theme.spacing(2, 0, 2),
    backgroundColor: XMEI_PRIMARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
  },
  mr16: {
    marginRight: '1.6em',
  },
  textContent: { fontSize: 18, color: '#202020', fontWeight: 'bold' },
  label: { fontSize: 15, color: '#ACABB9' },
  viewRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
  },
  viewColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10,
  },
  viewValue: { marginLeft: '5%' },
  marginBottom: { marginBottom: 10 },
}));

export const InputButton = withStyles(() => ({
  root: {
    marginTop: '0.6em',
    padding: '15px 14px',
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: XMEI_SECONDARY_COLOR,
    },
  },
}))(Button);
